<template>
  <section class="page-hero" :class="{'page-hero--ruled': ruled}">
    <div class="container">
      <breadcrumbs v-if="breadcrumbs && breadcrumbs.length > 1" :items="breadcrumbs"/>
      <h1>{{ title }}</h1>
      <p v-if="lead" class="lead" @click="onClick" v-html="lead"></p>
      <div v-if="$slots.default" class="actions">
        <slot/>
      </div>
    </div>
  </section>
</template>

<script>
  import Breadcrumbs from "@/components/Breadcrumbs.vue";
  import {followInternalLink} from "@/seo/internalLinks";

  /**
   * En-tête d'une page intérieure : fil d'Ariane, titre h1, chapeau et boutons (slot).
   * Le chapeau accepte le balisage de src/seo/inline.js déjà converti en HTML par la vue.
   */
  export default {
    name: 'BannerComponent',
    components: {Breadcrumbs},
    props: {
      title: {type: String, required: true},
      lead: {type: String, default: ''},
      breadcrumbs: {type: Array, default: () => []},
      ruled: {type: Boolean, default: false},
    },
    methods: {
      onClick(event) {
        followInternalLink(event, this.$router);
      },
    },
  }
</script>

<style lang="stylus" scoped>
@import '~/src/common/style/constants.styl';

.page-hero
  padding-top clamp(28px, 5vw, 56px)
  padding-bottom clamp(32px, 5vw, 56px)
  border-bottom 1px solid RULE
  h1
    max-width 22ch
    margin-top 20px
  .lead
    margin-top 18px
  .actions
    margin-top 28px
    display flex
    flex-wrap wrap
    gap 12px

.page-hero--ruled
  background-color WHITE
  background-image repeating-linear-gradient(to bottom, transparent 0, transparent 35px, rgba(203, 216, 197, 0.4) 35px, rgba(203, 216, 197, 0.4) 36px)

@media (min-width: DESKTOP_SIZE)
  .page-hero h1
    max-width 26ch
</style>
